import Vue from 'vue';

// Vue.component('app-confirm',
//   () => import('./components/AppConfirm.vue'));

// Project Specific
Vue.component('al-project-form', () => import('@/components/ProjectForm.vue'));
Vue.component('al-import-json-form', () => import('@/components/ImportJSONForm.vue'));
Vue.component('al-project-accounts-form', () => import('@/components/ProjectAccountsForm.vue'));
Vue.component('al-empty-results', () => import('@/components/EmptyResults.vue'));
Vue.component('al-project-breadcrumb', () => import('@/modules/projects/ProjectBreadcrumb.vue'));

// Issue Specific
Vue.component('user-info', () => import('./modules/issues/common/UserInfo.vue'));
Vue.component('issue-status', () => import('./modules/issues/common/Status.vue'));
Vue.component('issue-priority', () => import('./modules/issues/common/Priority.vue'));
Vue.component('issue-stats', () => import('./modules/issues/common/Stats.vue'));
Vue.component('issue-desc', () => import('./modules/issues/IssueDescription.vue'));
